enum ClientBalanceEnum {
  relTypeQuote = 0,
  relTypeForwardRequest = 1,
  relTypeManualTopUpByAdmin = 2,
  relTypeBalanceTopUp = 3,
  relTypeMiscInvoice = 4,
  typeAddition = 1,
  typeDeduction = 2,
}

export default ClientBalanceEnum
